import "../css/company-financials.css";

import { useState, useEffect, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RadioSelector } from "../utils/Constants/systemSetting";

import {
  getFiscalData,
  getFiscalStockPrice,
} from "../redux/actions/CompanyAction";
import { FinancialTable } from "./CompanyFinancials/_financialUtils";
import CohortSelector from "./ExecutiveOverview/CohortSection/CohortSelector";

// import DailyPricesGraph from "./CompanyFinancials/DailyPricesGraph";
import PuffLoader from "react-spinners/PuffLoader";
import DailyPricesGraph from "./CompanyFinancials/DailyPricesGraph";

//TODO: Replace "Current Stock Price" with "Stock Price" if we pay for stock prices module
//TODO: Also replace stock price "price" keys with "ratio" (see other TODOs)
//TODO: Check DailyPricesGraph import for similar changes

const financialOptions = [
  {
    title: "Income Statement",
    backendName: "Income Statement",
    valuesKey: "metricsValues",
    standardizedOptionAvailable: true,
  },
  {
    title: "Balance Sheet",
    backendName: "Balance Sheet",
    valuesKey: "metricsValues",
    standardizedOptionAvailable: true,
  },
  {
    title: "Cash Flow",
    backendName: "Cash Flow Statement",
    valuesKey: "metricsValues",
    standardizedOptionAvailable: true,
  },
  {
    title: "Financial Ratios",
    backendName: "Company Ratios",
    valuesKey: "metricValues",
  },
  // {
  //   title: "Adjusted Metrics",
  //   backendName: "Adjusted Metrics",
  //   valuesKey: "metricValues",
  // },
];

export default function CompanyFinancials({ companyInfo, PDFprocessing }) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.UserReducer);
  const { subscription } = useSelector((state) => state.CustomerReducer);
  const isTier2 = useMemo(() => {
    if (user?.tier2access || subscription?.plan?.metadata?.isTier2 === "true") {
      return true;
    }
    return false;
  }, [user, subscription]);
  const { financialData } = useSelector((state) => state.CompanyReducer);
  const { stockPrice } = useSelector((state) => state.CompanyReducer);
  const { companies } = useSelector((state) => state.CompaniesReducer);

  const financialOptionsTitles = financialOptions.map((item) => item.title);

  const [financialOptionSelected, setFinancialOptionSelected] =
    useState("Income Statement");

  const [peerFinancialOptionSelected, setPeerfinancialOptionSelected] =
    useState("");

  const standardizedOptions = ["As Reported", "Standardized"];
  const [isStandardized, setIsStandardized] = useState("As Reported");

  const [cohortTableTickers, setCohortTableTickers] = useState([]);
  const [cohortSelected, setCohortSelected] = useState("None");

  const [companySpecificUpdateNeeded, setcompanySpecificUpdateNeeded] =
    useState(true);

  const [yearInterval, setYearInterval] = useState("5yr");
  const YearIntervalsAvailable = [
    "1yr",
    "2yr",
    "3yr",
    "4yr",
    "5yr",
    "7yr",
    "10yr",
  ];

  const generateFiscalYearOptions = (minYear, maxYear) => {
    const fisalYears = [];
    for (let year = maxYear; year >= minYear; year--) {
      fisalYears.push(year);
    }
    return fisalYears.map((yr) => `FY ${yr}`);
  };

  const [peerFiscalYearSelected, setPeerFiscalYearSelected] = useState("");
  const minYear = 2014;
  const maxYear = 2025;
  const fiscalYearOptions = generateFiscalYearOptions(minYear, maxYear);

  const currentFiscalYearSelected = useMemo(() => {
    return parseInt(peerFiscalYearSelected.replace("FY ", ""));
  }, [peerFiscalYearSelected]);

  const [dataPeriodType, setDataPeriodType] = useState("Annual");
  // const [dataPeriodType, setdataPeriodType] =
  //   useState("Annual");

  const [peerQuarterSelected, setPeerQuarterSelected] = useState("Q4");

  const [monitaryUnitSelected, setMonitaryUnitSelected] = useState("$");

  const dataPeriodTypesAvailable = [
    "Annual",
    "Quarterly",
    "Semi-Annual",
    "LTM",
    "YTD",
    "Latest",
  ];
  const dataPeriodTypeSelected = useMemo(() => {
    const dataPeriodTypeMap = {
      Annual: "annual",
      Quarterly: "quarterly",
      "Semi-Annual": "semi-annual",
      LTM: "ltm",
      YTD: "ytd",
      Latest: "latest",
    };
    return dataPeriodTypeMap[dataPeriodType];
  }, [dataPeriodType]);

  // const dataPeriodTypeSelected = useMemo(() => {
  //   const dataPeriodTypeMap = {
  //     Annual: "annual",
  //     Quarterly: "quarterly",
  //     "Semi-Annual": "semi-annual",
  //     LTM: "ltm",
  //     YTD: "ytd",
  //     Latest: "latest",
  //   };
  //   return dataPeriodTypeMap[dataPeriodType];
  // }, [dataPeriodType]);

  const [loadingNewData, setLoadingNewData] = useState(false);
  const [loadingNewPeerData, setLoadingNewPeerData] = useState(false);

  const financialOptionSelectedDetails = useMemo(() => {
    const currentOptionDetails = financialOptions.find(
      (item) => item.title === financialOptionSelected,
    );
    currentOptionDetails["fullBackendName"] = `${
      currentOptionDetails.backendName
    }${
      currentOptionDetails?.standardizedOptionAvailable &&
      isStandardized === "Standardized"
        ? " Standardized"
        : ""
    }`;
    setcompanySpecificUpdateNeeded(true);
    return currentOptionDetails;
  }, [financialOptionSelected, isStandardized]);

  const peerFinancialOptionSelectedDetails = useMemo(() => {
    if (!peerFinancialOptionSelected) {
      return {};
    }
    const currentOptionDetails = financialOptions.find(
      (item) => item.title === peerFinancialOptionSelected,
    );
    currentOptionDetails["peerFullBackendName"] = `${
      currentOptionDetails.backendName
    }${
      currentOptionDetails?.standardizedOptionAvailable ? " Standardized" : ""
    }`;
    return currentOptionDetails;
  }, [peerFinancialOptionSelected]);

  const [prevDataPeriodicity, setPrevDataPeriodicity] = useState("");

  // const [prevPeerDataPeriodicity, setPrevPeerDataPeriodicity] = useState("");
  const [prevFiscalYearSelected, setPrevFiscalYearSelected] = useState("");

  const [hiddenSubTables, setHiddenSubTables] = useState([]);
  const [hiddenPeerSubTables, setHiddenPeerSubTables] = useState([]);

  const currentStockPrice = useMemo(() => {
    const currentStockPrice =
      stockPrice?.[companyInfo.Ticker]?.result?.[0]?.ratio;

    if (!isNaN(parseFloat(currentStockPrice))) {
      return parseFloat(currentStockPrice).toFixed(2);
    }
    if (stockPrice?.[companyInfo.Ticker]) {
      return "N/A";
    }
    return null;
  }, [companyInfo, stockPrice]);

  const [loadingStockPrices, setLoadingStockPrices] = useState(false);

  useEffect(() => {
    const ticker = companyInfo?.Ticker;
    const CIK = companyInfo?.CIK;
    const token = localStorage.getItem("ACCESS_TOKEN");

    const backendDataName = financialOptionSelectedDetails.fullBackendName;
    const peerBackendDataName =
      peerFinancialOptionSelectedDetails.peerFullBackendName;

    if (ticker && token) {
      //TODO: replace ratio here with price if we pay for stock price module
      if (ticker && !stockPrice?.[companyInfo.Ticker]?.result?.[0]?.ratio) {
        dispatch(
          getFiscalStockPrice(
            "Current Stock Price",
            [ticker],
            [CIK], //CIKs
            null, //periodType
            null, //fiscalYearneeded
            "USD",
            true, //Pulls current stock price only "latest" = true
            token,
          ),
        );
      }

      if (
        ticker &&
        currentStockPrice &&
        currentStockPrice !== "N/A" &&
        !financialData?.["Current Stock Price"]?.[companyInfo?.Ticker]?.result
      ) {
        setLoadingStockPrices(true);
        dispatch(
          getFiscalData(
            "Current Stock Price",
            [ticker],
            [CIK], //CIKs
            null, //periodType
            null, //fiscalYearneeded
            "USD",
            false,
            token,
          ),
        );
      }

      if (
        ticker &&
        currentStockPrice &&
        currentStockPrice !== "N/A" &&
        financialData?.["Current Stock Price"]?.[companyInfo?.Ticker]?.result &&
        (financialData === undefined ||
          (typeof financialData === "object" &&
            typeof financialData?.[backendDataName]?.[ticker] !== "object") ||
          prevDataPeriodicity !== dataPeriodTypeSelected ||
          companySpecificUpdateNeeded)
      ) {
        setcompanySpecificUpdateNeeded(false);
        setPrevDataPeriodicity(dataPeriodTypeSelected);
        setLoadingStockPrices(false);
        setLoadingNewData(true);

        dispatch(
          getFiscalData(
            backendDataName,
            [ticker],
            [CIK], //CIKs
            dataPeriodTypeSelected,
            null, //fiscalYearneeded
            "USD",
            false,
            token,
          ),
        );
      }
      if (
        ticker &&
        cohortTableTickers.length &&
        currentStockPrice &&
        currentStockPrice !== "N/A" &&
        currentFiscalYearSelected &&
        financialData?.["Current Stock Price"]?.[companyInfo?.Ticker]?.result &&
        (financialData === undefined ||
          (typeof financialData === "object" &&
            cohortTableTickers.some(
              (cohortTicker) =>
                typeof financialData?.[peerBackendDataName]?.[cohortTicker] !==
                "object",
            )) ||
          prevDataPeriodicity !== dataPeriodTypeSelected ||
          prevFiscalYearSelected !== currentFiscalYearSelected)
      ) {
        setLoadingNewPeerData(true);
        setPrevDataPeriodicity(dataPeriodTypeSelected);
        setPrevFiscalYearSelected(currentFiscalYearSelected);
        dispatch(
          getFiscalData(
            peerBackendDataName,
            [ticker, ...cohortTableTickers.filter((item) => item !== ticker)],
            [
              CIK,
              ...cohortTableTickers
                .filter((item) => item !== ticker)
                .map((tick, index) => companies?.[tick]?.CIK || `N/A_${index}`),
            ],
            dataPeriodTypeSelected,
            dataPeriodTypeSelected === "latest"
              ? null
              : currentFiscalYearSelected,
            "USD",
            false,
            token,
          ),
        );
      }
    }
  }, [
    companyInfo,
    companies,
    financialOptionSelectedDetails,
    peerFinancialOptionSelectedDetails,
    prevFiscalYearSelected,
    isStandardized,
    financialData,
    stockPrice,
    currentStockPrice,
    dataPeriodTypeSelected,
    currentFiscalYearSelected,
    prevDataPeriodicity,
    cohortTableTickers,
    companySpecificUpdateNeeded,
    dispatch,
  ]);

  useMemo(() => {
    const ticker = companyInfo?.Ticker;
    const backendName = financialOptionSelectedDetails.fullBackendName;
    if (typeof financialData?.[backendName]?.[ticker] === "object") {
      setLoadingNewData(false);
    }
  }, [companyInfo, financialOptionSelectedDetails, financialData]);

  useMemo(() => {
    const backendName = peerFinancialOptionSelectedDetails.peerFullBackendName;
    if (
      cohortTableTickers.every(
        (ticker) => typeof financialData?.[backendName]?.[ticker] === "object",
      )
    ) {
      setLoadingNewPeerData(false);
    }
  }, [cohortTableTickers, peerFinancialOptionSelectedDetails, financialData]);

  const FormattedFinancialTable = useCallback(
    ({
      companyInfo,
      financialData,
      financialOptionSelectedDetails,
      // dataPeriodTypeSelected,
      hiddenSubTables,
      loadingNewData,
    }) => {
      const ticker = companyInfo.Ticker;
      const backendDataName = financialOptionSelectedDetails.fullBackendName;
      const valuesKey = financialOptionSelectedDetails.valuesKey;
      const loading = loadingNewData;

      const currentRawData =
        financialData?.[backendDataName]?.[ticker]?.result?.metrics;
      let useCatgories = false;

      if (Array.isArray(currentRawData) && dataPeriodTypeSelected) {
        const allSubTableNames = [];
        for (const metricDetails of currentRawData) {
          if (
            metricDetails?.headers &&
            metricDetails.headers.length &&
            !allSubTableNames.includes(metricDetails.headers[0])
          ) {
            useCatgories = false;

            allSubTableNames.push(metricDetails.headers[0]);
          }
          if (
            metricDetails?.category &&
            !allSubTableNames.includes(metricDetails.category)
          ) {
            useCatgories = true;
            allSubTableNames.push(metricDetails.category);
          }
        }

        return (
          <>
            <FinancialTable
              rawData={financialData}
              backendDataName={backendDataName}
              subTableNames={allSubTableNames}
              ticker={ticker}
              valuesKey={valuesKey}
              dataPeriodTypeSelected={dataPeriodTypeSelected}
              useCatgories={useCatgories}
              hiddenSubTables={hiddenSubTables}
              setHiddenSubTables={setHiddenSubTables}
              monitaryUnitSelected={monitaryUnitSelected}
              loading={loading}
            />
          </>
        );
      }

      return <>Loading...</>;
    },
    [dataPeriodTypeSelected, monitaryUnitSelected],
  );

  const FormattedPeerFinancialTable = useCallback(
    ({
      companyInfo,
      financialData,
      financialOptionSelectedDetails,
      loadingNewData,
      peerGroupTable = false,
      currentFiscalYearSelected = null,
      dataPeriodicitySelected = dataPeriodTypeSelected,
      cohortTableTickers = [],
    }) => {
      const ticker = companyInfo.Ticker;
      const backendDataName =
        peerFinancialOptionSelectedDetails.peerFullBackendName;

      const valuesKey = financialOptionSelectedDetails.valuesKey;
      const loading = loadingNewData;

      const currentRawData =
        financialData?.[backendDataName]?.[ticker]?.result?.metrics;
      let useCatgories = false;

      if (Array.isArray(currentRawData)) {
        const allSubTableNames = [];
        for (const metricDetails of currentRawData) {
          if (
            metricDetails?.headers &&
            metricDetails.headers.length &&
            !allSubTableNames.includes(metricDetails.headers[0])
          ) {
            useCatgories = false;

            allSubTableNames.push(metricDetails.headers[0]);
          }
          if (
            metricDetails?.category &&
            !allSubTableNames.includes(metricDetails.category)
          ) {
            useCatgories = true;
            allSubTableNames.push(metricDetails.category);
          }
        }
        const quarterNumberSelected = parseInt(
          peerQuarterSelected.replace("Q", ""),
        );

        return (
          <>
            <FinancialTable
              rawData={financialData}
              backendDataName={backendDataName}
              subTableNames={allSubTableNames}
              ticker={ticker}
              valuesKey={valuesKey}
              dataPeriodTypeSelected={dataPeriodicitySelected}
              useCatgories={useCatgories}
              hiddenSubTables={hiddenPeerSubTables}
              setHiddenSubTables={setHiddenPeerSubTables}
              monitaryUnitSelected={monitaryUnitSelected}
              loading={loading}
              peerGroupTable={peerGroupTable}
              currentFiscalYearSelected={currentFiscalYearSelected}
              cohortTableTickers={cohortTableTickers}
              peerQuarterSelected={quarterNumberSelected}
              cohortSelected={cohortSelected}
            />
          </>
        );
      }
      if (
        peerGroupTable &&
        (!peerFinancialOptionSelected ||
          !peerFiscalYearSelected ||
          (!["Annual", "Latest"].includes(dataPeriodType) &&
            peerQuarterSelected))
      ) {
        return (
          <p style={{ marginLeft: 20, fontSize: 16, marginTop: 15 }}>
            Select a{" "}
            {!peerFinancialOptionSelected ? (
              <span>
                <b>Financial Data</b> type
              </span>
            ) : (
              <b>Fiscal Year</b>
            )}{" "}
            to compare.
          </p>
        );
      }
      return (
        <center
          style={{
            height: "150px",
            marginTop: "130px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PuffLoader color={"var(--loader)"} loading={true} size={90} />
        </center>
      );
    },
    [
      hiddenPeerSubTables,
      dataPeriodTypeSelected,
      dataPeriodType,
      peerFinancialOptionSelected,
      peerFinancialOptionSelectedDetails,
      peerFiscalYearSelected,
      peerQuarterSelected,
      monitaryUnitSelected,
      cohortSelected,
    ],
  );

  useMemo(() => {
    //Reset the hidden tables if youre going between data views
    if (financialOptionSelected || isStandardized) {
      setHiddenSubTables([]);
    }
  }, [financialOptionSelected, isStandardized]);

  // useMemo(() => {
  //   console.log(financialData);
  // }, [financialData]);

  return (
    <>
      {!isTier2 ? (
        <div
          className="comp-ai-section col-lg-9 executives "
          style={{ height: "100%", padding: 50 }}
        >
          <h3
            style={{
              textAlign: "center",
              fontWeight: "normal",
              fontSize: 22,
            }}
          >
            <p style={{ fontWeight: "bold" }}>
              This page is for C-Suite Comp&reg; Enterprise users only.
            </p>
            <br />
            <p>
              Contact your account manager to access finanical module data
              including income statements, cash flow, adjusted metrics and
              financial ratios and how these compare to your peers
            </p>
          </h3>
        </div>
      ) : currentStockPrice === null ? (
        <div
          className="comp-ai-section col-lg-9 executives p-0"
          style={{ height: "100%", padding: 50 }}
        >
          <h2 style={{ textAlign: "center", marginBottom: 0 }}>
            Company Financials
          </h2>
          <h3
            style={{
              textAlign: "center",
              fontWeight: "normal",
              fontSize: 20,
              marginTop: 20,
            }}
          >
            Loading...
          </h3>
          <center
            style={{
              height: "150px",
              marginTop: "130px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PuffLoader
              color={"var(--loader)"}
              loading={currentStockPrice === null}
              size={90}
            />
          </center>
        </div>
      ) : currentStockPrice === "N/A" ? (
        <>
          <div className="company-calculator-section col-lg-9 executives p-0">
            <h2 style={{ textAlign: "center", marginBottom: 0 }}>
              Company Financials
            </h2>
            <p style={{ textAlign: "center", marginTop: 35, fontSize: 24 }}>
              Company Financials are not available for {companyInfo?.Ticker}
            </p>
          </div>
        </>
      ) : (
        <>
          <div className="company-calculator-section col-lg-9 executives p-0">
            <h2 style={{ textAlign: "center", marginBottom: 0 }}>
              Company Financials
            </h2>

            <div style={{ marginTop: 15 }} />
            <div style={{ marginLeft: 62.5 }}>
              <h2>Share Price</h2>
            </div>
            <DailyPricesGraph
              companyInfo={companyInfo}
              loadingStockPrices={loadingStockPrices}
            />
          </div>
          <div className="company-calculator-section col-lg-12 executives p-0">
            <RadioSelector
              options={financialOptionsTitles}
              state={financialOptionSelected}
              setState={setFinancialOptionSelected}
              heading="Select Financial Data:"
              style={{ marginBottom: 10, marginTop: 20 }}
            />
            <p
              style={{
                marginLeft: 5,
                marginTop: 17.5,
                marginBottom: -5,
                textAlign: "end",
                fontSize: 14,
              }}
            >
              Company Financials Data Powered by{" "}
              <a href="http://fiscal.ai">Fiscal.ai</a>
            </p>
            <h2>{financialOptionSelected}</h2>
            {["Income Statement", "Balance Sheet", "Cash Flow"].includes(
              financialOptionSelected,
            ) && (
              <RadioSelector
                options={standardizedOptions}
                state={isStandardized}
                setState={setIsStandardized}
                heading="Select Reporting Type:"
                optionsHoverTextMap={{
                  "As Reported":
                    "Returns raw financial statement line items exactly as disclosed by the company.",
                  Standardized:
                    "Returns standardized financial statements where line items are mapped to a common schema, enabling apples-to-apples comparison across companies.",
                }}
              />
            )}
            <RadioSelector
              options={dataPeriodTypesAvailable}
              state={dataPeriodType}
              setState={setDataPeriodType}
              heading="Data Period Type:"
            />
            <RadioSelector
              options={["$", "K", "M", "B"]}
              state={monitaryUnitSelected}
              setState={setMonitaryUnitSelected}
              optionsHoverTextMap={{
                $: "Dollar amount",
                K: "Thousands",
                M: "Millions",
                B: "Billions",
              }}
              heading="Data View:"
            />
            {/* <RadioSelector
              options={YearIntervalsAvailable}
              state={yearInterval}
              setState={setYearInterval}
              heading="Data Range:"
            /> */}
            <div style={{ marginTop: 12.5 }} />

            <FormattedFinancialTable
              companyInfo={companyInfo}
              financialData={financialData}
              financialOptionSelectedDetails={financialOptionSelectedDetails}
              dataPeriodTypeSelected={dataPeriodTypeSelected}
              hiddenSubTables={hiddenSubTables}
              loadingNewData={loadingNewData}
            />
          </div>
          <div className="company-calculator-section executives">
            <div style={{ margin: 10 }} />
            <hr />
            <h2 style={{ textAlign: "center" }}>Peer Group Comparison</h2>
            <p style={{ textAlign: "center" }}>
              Select a Comparison Group to compare to {companyInfo.Company}
              's Financials:
            </p>
            <CohortSelector
              heading={"Select Comparison Group:"}
              companyInfo={companyInfo}
              setCohortTableTickers={setCohortTableTickers}
              cohortTableSelector={cohortSelected}
              setCohortTableSelector={setCohortSelected}
              removeCustomCohort={true}
              additionalOptions={["None"]}
              onlyIncludePeerGroups={true}
            />

            {cohortTableTickers.length ? (
              <div>
                <RadioSelector
                  options={financialOptionsTitles}
                  state={peerFinancialOptionSelected}
                  setState={setPeerfinancialOptionSelected}
                  heading="Select Financial Data:"
                />
                {peerFinancialOptionSelected && (
                  <RadioSelector
                    options={fiscalYearOptions}
                    state={peerFiscalYearSelected}
                    setState={setPeerFiscalYearSelected}
                    heading="Select Fiscal Year:"
                  />
                )}
                {peerFiscalYearSelected && (
                  <RadioSelector
                    options={dataPeriodTypesAvailable}
                    state={dataPeriodType}
                    setState={setDataPeriodType}
                    heading="Data Period Type:"
                  />
                )}

                {!["Annual", "Latest"].includes(dataPeriodType) && (
                  <RadioSelector
                    options={
                      dataPeriodTypeSelected === "semi-annual"
                        ? ["Q2", "Q4"]
                        : ["Q1", "Q2", "Q3", "Q4"]
                    }
                    state={peerQuarterSelected}
                    setState={setPeerQuarterSelected}
                    heading="Select Quarter:"
                  />
                )}
                {peerFinancialOptionSelected && peerFiscalYearSelected && (
                  <RadioSelector
                    options={["$", "K", "M", "B"]}
                    state={monitaryUnitSelected}
                    setState={setMonitaryUnitSelected}
                    optionsHoverTextMap={{
                      $: "Dollar amount",
                      K: "Thousands",
                      M: "Millions",
                      B: "Billions",
                    }}
                    heading="Data View:"
                  />
                )}

                {dataPeriodTypeSelected === "semi-annual" &&
                !["Q2", "Q4"].includes(peerQuarterSelected) ? (
                  <p>Please select a valid semi-annual quarter</p>
                ) : (
                  <FormattedPeerFinancialTable
                    companyInfo={companyInfo}
                    financialData={financialData}
                    financialOptionSelectedDetails={
                      peerFinancialOptionSelectedDetails
                    }
                    loadingNewData={loadingNewPeerData}
                    peerGroupTable={true}
                    currentFiscalYearSelected={currentFiscalYearSelected}
                    dataPeriodicitySelected={dataPeriodTypeSelected}
                    cohortTableTickers={cohortTableTickers}
                  />
                )}
              </div>
            ) : null}
          </div>
        </>
      )}
    </>
  );
}
